import HeaderComponent from "../HeaderComponent";
import Breadcrumb from "../../wrapper/Breadcrumb";
import React, {useEffect, useRef, useState} from "react";
import "../../css/yourStroy.css";
import {getRefreshToken, getTokenFromSession, refreshIdToken} from "../../services/authenticate";
import config from "../../Config/config";
import LoginPage from "../login";
import Footer from "../../assets/Footer";
import {Link} from "react-router-dom";
import {Spinner} from "react-bootstrap";
import axios from "axios";

const StoryList = ({searchTerm, setSearchTerm, genres}) => {
    const [storyCard, setStoryCard] = useState([]);
    const [showLogin, setShowLogin] = useState(false);
    const [loading, setLoading] = useState(false);
    const intervalIdRef = useRef(null);

    useEffect(() => {
        const fetchStoryCards = async () => {
            const token = getTokenFromSession();
            setLoading(true);
            try {
                const response = await axios.get(`${config.api.story}`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `${token}`,
                    }
                });
                if (response.status === 200) {
                    const newData = response.data;
                    const formattedData = newData.map(item => ({
                        customerId: item.customerId,
                        storyId: item.storyId,
                        title: item.title,
                        image: item.image,
                        status:item.status
                    }));
                    setStoryCard(formattedData);
                    const allReady = formattedData.every(item => item.title && item.title.trim().length > 1);
                    if (allReady && intervalIdRef.current) {
                        clearInterval(intervalIdRef.current);
                        intervalIdRef.current = null;
                    }
                }
                if (response.status === 204) {
                    alert("No story found");
                }
            } catch (error) {
                if (error.response) {
                    console.log("Error Status:", error.response.status);
                    if (error.response.status === 401 || error.response.status === 403) {
                        console.log("Unauthorized or forbidden. Attempting token refresh.");
                        const refersToken = getRefreshToken();
                        if (!refersToken) {
                            const userConfirmed = window.confirm(
                                "Please sign in to submit your Story. If you don't have an account, please create one."
                            );
                            if (userConfirmed) {
                                setShowLogin(true);
                                setLoading(false);
                                return;
                            }
                        }
                        await refreshIdToken(refersToken);
                        await fetchStoryCards();
                    }
                }
            } finally {
                setLoading(false);
            }
        };

        fetchStoryCards().then();
        intervalIdRef.current = setInterval(fetchStoryCards, 30000);
        return () => {
            if (intervalIdRef.current) {
                clearInterval(intervalIdRef.current);
            }
        };
    }, []);


    return (
        <div>
            <HeaderComponent
                searchTerm={searchTerm}
                handleSearch={setSearchTerm}
                genres={genres}
            />
            <div style={{marginTop: "200px"}}></div>
            <Breadcrumb
                pages={[
                    {label: "Home", path: "/"},
                    {label: "Story", path: "/story"},
                ]}
            />
            <div className="yourStory-container">
                {loading ? (
                    <div className="text-center my-5">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : (storyCard.length === 0) ? (
                    <p>No story found</p>
                ) : (
                    storyCard.map((item, index) => (
                        <div key={index} className="story-card">
                            {item.title.length > 1 ? (
                                <>
                                    <Link to={`/story/${item.storyId}`}>
                                        <img src={item.image} alt={item.title}/>
                                    </Link>
                                    <span>Title: {item.title}</span>
                                </>
                            ) : (
                                <>
                                {item.status !="INITIATED" &&(
                                    <>
                                    <span>your story is getting ready</span>
                                    <Spinner animation="border" role="status"/>
                                    </>
                                )}
                                   
                                </>
                            )}
                        </div>
                    ))
                )}
            </div>
            <LoginPage show={showLogin} handleClose={() => setShowLogin(false)}/>
            <div style={{marginTop: "550px"}}>
                <Footer/>
            </div>
        </div>
    );
};

export default StoryList;
